import cx from 'classnames';
import React, { useState } from 'react';

const InputText = (props) => {
  const {
    id,
    label,
    className,
    placeholder,
    value,
    type,
    error,
    onChange,
    disabled = false,
    ...rest
  } = props;

  const [currentValue, setCurrentValue] = useState(value || '');

  // sync external value changes
  React.useEffect(() => {
    if (value !== undefined && value !== currentValue) {
      setCurrentValue(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const onChangeHandler = (e) => {
    const nextVal = e.target.value;
    setCurrentValue(nextVal);
    onChange && onChange(e);
  };

  return (
    <div className={cx('field field_col', className)}>
      <label className="field__label" htmlFor={id}>
        {label}
      </label>

      <input
        type={type || 'text'}
        className={cx('field__input', { disabled: disabled })}
        placeholder={placeholder}
        id={id}
        name={id}
        value={currentValue}
        onChange={onChangeHandler}
        disabled={disabled}
        {...rest}
      />

      {error && <div className="field__error">{error}</div>}
    </div>
  );
};

export default InputText;
